<template src="./VehicleForm.html"></template>
<script>
import Vue from "vue";
import { notifyError } from "@/utils/notification-helper";
import { UploadInstaller } from "@progress/kendo-upload-vue-wrapper";
import { Grid } from "@progress/kendo-vue-grid";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters } = createNamespacedHelpers("vehicle");
import fileUploadCell from "@/components/FileUploadCell/FileUploadCell.vue";
import FormGenerator from "@/components/Fields/FormGenerator";
Vue.component("Grid", Grid);
import { BTabs } from "bootstrap-vue";
import ViewFile from "./ViewFile";
import DialogBox from "@/components/DialogBox";
import FileUpload from "./FileUpload";
import moment from 'moment';
// import { validateVehicleNumber } from "@/utils/util";
// import { MESSAGES } from "@/utils/constants";

Vue.use(UploadInstaller);
Vue.component("b-tabs", BTabs);
export default {
  components: {
    ViewFile,
    FormGenerator,
    DialogBox,
    FileUpload,
  },
  data: function() {
    return {
      gridHeight: window.innerHeight - 180,
      vehicleData: {},
      editField: false,
      editId: null,
      items: [],
      open: false,
      url: "",
      dataItems: [],
      value: "",
      vehicleType: "",
      driverVal:null,
      vendorValue:"",
      fuelVal:"",
      modelValue:"",
      vehicleTypes: [],
      emp_data: {},
      imeiFilter: {},
      driverListV2: [],
      imeiObj:{},
      vehicleNumberInvalid: null,
      commonVehicleModel:[],
      vehicleFuelTypes:[],
      FileUploadcolumns: [
        { field: "id", title: "S.No" },
        { field: "fileName", title: "File Name" },
        { field: "fileUrl", title: "File URL" },
        { field: "fileType", title: "File Type" },

        { cell: fileUploadCell, title: "Actions", width: "300px" },
      ],
      columns: [
        { field: "imei", title: "IMEI Number" },
        { field: "startDate", title: "Start Date" },
        { field: "endDate", title: "End Date" },
      ],
      // fuelTypes: [
      //   {name: 'Petrol', id: 'P'},
      //   {name: 'Diesel', id: 'D'},
      //   {name: 'Electric', id: 'E'},
      //   {name: 'LPG', id: 'L'},
      // ],

      template:
        "<span class='k-progress'></span>" +
        "<div class='file-wrapper'>" +
        "<span class='file-icon img-file'></span>" +
        "<h4 class='file-heading file-name-heading'>Name: #=name#</h4>" +
        "<h4 class='file-heading file-size-heading'>Size: #=size# bytes</h4>" +
        "<strong class='k-upload-status'>" +
        "<button type='button' " +
        "class='k-upload-action'></button>" +
        "<button type='button' class='k-upload-action'></button>" +
        "</strong>" +
        "</div>",
    };
  },
  computed: {
    ...mapState({
      fileIem: (state) => state.vehicleFileList,
      formData: (state) => state.metadata,
      schema: (state) => state.additionalDetails,
      // fuelTypes: (state) => state.vehicleFuelTypes,
      vehicleModels: (state) => state.vehicleModels,
      devices: (state) => state.devices,
      
    }),
    ...mapGetters([
      "getIMEINumbers","getVehicleModelDropdown","getVehicleFuelTypes"
    ]),

    vendorList() {
      console.log('#VENDOR LIST');
      return this.$store.state.vendors;

    },
    billingList() {
      return this.$store.state.BillFilterdData;
    },
    vehicleTypeData() {
      return this.$store.state.vehicleType;
    },
    allowVendor() {
      return this.$store.state.allowVendorSelection;
    },
    // Used in beforemount
    getDriverList() {
      let arr = [];
      // console.log('Computed driver list : ', );
      if (this.vehicleData.vendorID)
        arr =  this.$store.state.drivers.filter(
          driver => {
            if (driver.vendorID === this.vehicleData.vendorID.id) {
              return true;
            }
          }
        );
      return arr;
    },
    vehicleFuelTypesDropdown(){
      return this.$store.getters["vehicle/getVehicleFuelTypes"]

    }
  },
  created() {
    this.getVehicle();
    this.getDataOnload();
  },
  // watch: {
  //   vehicleType() {
  //     return this.vehicleData.vehicleTypeID
  //       ? this.vehicleData.vehicleTypeID.id
  //       : null;
  //   },
  // },
  mounted() {
    this.getVehicle();
    this.expandPanel();
  },

  methods: {
    // validateRTONumber(e) {
    //   if (!e.target.value) {
    //     this.vehicleNumberInvalid = null
    //     return;
    //   }
    //   if (validateVehicleNumber(e.target.value))
    //     this.vehicleNumberInvalid = null
    //   else 
    //     this.vehicleNumberInvalid = MESSAGES.INVALID_VEHICLE_NUMBER;
    // },
    changeVendor(e) {
      // console.log('e',e,this.vehicleData.vendorID)
     this.vendorValue = e.target.value
      this.vehicleData.driverID = '';
    },
    filterChange (event) {
      // vehicle.imeiFilters = this.filterData(event.filter);
      console.log("hhh",event.filter);
      this.imeiFilter = event.filter;
    },
    changeIME(e){
      this.imeiObj = e.target.value
       console.log("hhh",e)
    },
      changeFuel(e) {
      // console.log('e',e,this.vehicleData.vendorID)
     this.fuelVal = e.target.value
    
    },
    modelChange(e){
      this.modelValue = e.target.value
    },
    goToListPage: function() {
      this.$store.commit("vehicle/clearFields");
      this.$store.commit("vehicle/cancel");
      this.$router.push({ name: "vehicle-management", });
    },
    async getVehicle() {
      this.vehiclelist = this.$store.getters["vehicle/vehicleData"];
    },
    changeType(e) {
     
      this.vehicleType = this.vehicleData.typeID
        ? this.vehicleData.typeID.vehicleTypeID
        : null;
        //  console.log("change", this.vehicleType,e.target.value.vehicleTypeID);
           this.$store.commit("getBillData",e.target.value.vehicleTypeID);
          this.vehicleData.billingType = this.billingList.find( (obj) => obj.billCategory.isDefault == true)
            // console.log("change", this.billingList);
    },
    changeDriverType(){
       this.driverVal = this.vehicleData.driverID
    },
    async getDataOnload() {
      
      // this.expandPanel();
      // this.vehicleData.vendorID = !this.allowVendor ? this.vendorList[0] : null;
      try{
      //  await this.$store.dispatch("vehicle/vehicleModelDropdown");
      await this.$store.dispatch("vehicle/getColumn");
      }
      catch(e){
        console.log("#err",e);
      }

      // console.log(this.billingList);
      // this.$store.dispatch("vehicle/getVehicleFileList", this.vehicleData.id);
    },
    resetData : function () {
      this.vehicleData = {};
    },
    addVehicle: function() {
      // this.vehicleData.vendorID = this.vehicleData.vendorID.id;
        this.$refs.fileUpload.submitFiles();
        console.log('validation saving....');

        console.info(
          'rtoNumber :', this.vehicleData.rtoNumber ,
          'vehicleType :', this.vehicleData.vehicleType ,
          'driverID :', this.vehicleData.driverID ,
          'fuelType :', this.vehicleData.vehicleFuelType,
        );

      if (
        this.vehicleData.rtoNumber &&
        this.vehicleData.vehicleType 
      ) 
      {
        const maintenanceDueDate=moment(this.vehicleData.maintenanceDueDate,"DD/MM/YYYY")
        maintenanceDueDate.set({hour: 23, minute: 59, second: 59})
        const taxExpiryDate=moment(this.vehicleData.taxExpiryDate,"DD/MM/YYYY")
        taxExpiryDate.set({hour: 23, minute: 59, second: 59})
        const insuranceExpiry=moment(this.vehicleData.insuranceExpiry,"DD/MM/YYYY")
        insuranceExpiry.set({hour: 23, minute: 59, second: 59})
        const permitEnd=moment(this.vehicleData.permitEnd,"DD/MM/YYYY")
        permitEnd.set({hour: 23, minute: 59, second: 59})
        const fcExpiryDate=moment(this.vehicleData.fcExpiryDate,"DD/MM/YYYY")
        fcExpiryDate.set({hour: 23, minute: 59, second: 59})
        const emissionExpiry=moment(this.vehicleData.emissionExpiry,"DD/MM/YYYY")
        emissionExpiry.set({hour: 23, minute: 59, second: 59})
        console.log("data",this.vehicleData)
        let data = {
          // ...this.vehicleData,
          displayName: this.vehicleData.displayName,
          rtoNumber: this.vehicleData.rtoNumber,
          dateOfStart: this.vehicleData.dateOfStart,
          seatCount: this.vehicleData.seatCount
            ? Number(this.vehicleData.seatCount)
            : null,
          model: this.vehicleData.model,
          vehicleType: this.vehicleData.vehicleType.id,
          vehicleTypeID: this.vehicleData.vehicleType.id,
            // ? this.vehicleData.typeID.vehicleTypeID
            // : null,
          taxExpiryDate: taxExpiryDate.toISOString(),
          insuranceExpiry: insuranceExpiry.toISOString(),
          permitEnd: permitEnd.toISOString(),
          fcExpiryDate: fcExpiryDate.toISOString(),
          emissionExpiry: emissionExpiry.toISOString(),
          fuelType: this.vehicleData.vehicleFuelType.id.toString(),
          vendorID: this.vehicleData.vendorID
            ? this.vehicleData.vendorID.id
            : null,
          maintenanceDueDate: maintenanceDueDate.toISOString(),
          imei: this.vehicleData.imeiObj ? this.vehicleData.imeiObj.imei : null,
          Metadata: this.formData,
          driverID: this.vehicleData.driverID
            ? this.vehicleData.driverID.id
            : null,
          name: null,
          // billingTypeID: 0, //this.vehicleData.billingTypeID,
        };
        if (!this.editField) {
          this.$store.dispatch("vehicle/addVehicle", data).then((response) => {
            if(response.status >= 200 && response.status <= 210) {
              this.goToListPage();
              this.resetData();
            }
          }).catch((err) => {
            console.error(err);
            // notifyError(err.response.data.message);
          })
        } else {
          console.log("data",data)
          let id = this.vehicleData.id;
          this.$store
            .dispatch("vehicle/updateVehicle", { id: id, data: data })
            .then(() => {
              this.goToListPage();
            }).catch((err) => {
              notifyError(err.response.data.message);
            }).finally(() => this.resetData());
        }
      }
      else {
        console.log('validation failing');
      }
    },
    fileUpload() {
      var t = this;
      var postFormData = function(url, data, fileEntry, xhr) {
        t.$store
          .dispatch("vehicle/uploadFile", {
            data: data,
            id: t.vehicleData.id,
          })
          .then(() => {
            t.$store.dispatch("vehicle/getVehicleFileList", t.vehicleData.id);
            t.fileClose();
            //t.upload._submitRemove = t.submitRemove;
          })
          .catch((err) => {
            console.error('FILE UPLOAD ERROR : ', err);
            t.fileClose();
          });
        var module = this;
        fileEntry.data("request", xhr);

        setTimeout(function() {
          var e = {
            target: { responseText: "", statusText: "OK", status: 200 },
          };
          module.onRequestSuccess.call(module, e, fileEntry);
        }, 1000);
      };
      var submitRemove = function(fileNames, eventArgs, onSuccess) {
        onSuccess();
      };

      var upload = this.$refs.upload.kendoWidget();
      upload._module.postFormData = postFormData;
      upload._submitRemove = submitRemove;
    },
    uploadFile() {
      var window = this.$refs.windowRef.kendoWidget();
      window.center().open();
      this.fileUpload();
    },
    fileClose() {
      var window = this.$refs.windowRef.kendoWidget();
      window.center().close();
    },

    view: function(e) {
      // this.open = true;
      // this.url = e.dataItem.fileUrl;
      this.$store.dispatch("vehicle/viewFile", e.dataItem.id).then(() => {
        const fileUrl = this.$store.getters["vehicle/fileUrlView"];
        window.open(fileUrl, "_blank");
      });
    },
    download(e) {
      this.$store.dispatch("vehicle/downloadFile", e.dataItem.id).then(() => {
        const fileUrl = this.$store.getters["vehicle/fileUrlDownload"];
        window.open(fileUrl, "_blank");
      });

      // this.$store
      //   .dispatch("vehicle/downloadFile", {
      //     url: e.dataItem.fileUrl,
      //     type: e.dataItem.fileName
      //   })
      //   .then(async () => {
      //     notify(MESSAGES.CHANGES_SAVE_SUCCESS);
      //   })
      //   .catch(notifyApiError);
    },
    setup: function() {
      return {
        rules: {
          getVehicle(input) {
            if (input.is("[name='VehicleType'") && input.val() == "") {
              return false;
            }

            return true;
          },
          getVendor(input) {
            if (input.is("[name='Vendor'") && input.val() == "") {
              return false;
            }
            return true;
          },
          // getDriver(input) {
          //   if (input.is("[name='Driver'") && input.val() == "") {
          //     return false;
          //   }
          //   return true;
          // },
          getBill(input) {
            if (input.is("[name='billing Type'") && input.val() == "") {
              return false;
            }
            return true;
          },
          getFuelType(input) {
            if (input.is("[name='fuel Type']") && input.val() == "") {
              return false;
            }
            return true;
          },
        },
        messages: {
          getVehicle: "Vehicle Type is required",
          getVendor: "vendor is required",
          getDriver: "Driver is required",
          getBill: "Billing is required",
          getFuelType: "Fuel Type is required",
        },
      };
    },
    remove(e) {
      this.dataItems = e;
      this.$refs.form.openWindow();
    },
    OkMethod() {
      let e = this.dataItems;

      this.$store.dispatch("vehicle/deleteFile", e.dataItem.id).then(() => {
        this.$store.dispatch("vehicle/getVehicleFileList", this.vehicleData.id);
      });
    },
    expandPanel() {
      let header = document.querySelectorAll('#panelbar .k-header');
      let element = document.querySelectorAll('#panelbar .k-content')[0];
      element.setAttribute('style','display:block !important');
      header[0].addEventListener('click', () => {
      if(element.getAttribute('style') == "display: block;") {
      element.setAttribute('style','display:none !important');
      }
      });
    },
    disableDates: function (date) {
    var d = new Date();
    var yesterday = d.setDate(d.getDate() - 1);
    return date < yesterday && date !=this.vehicleData.maintenanceDueDate && date !=this.vehicleData.emissionExpiry &&date !=this.vehicleData.taxExpiryDate&&date !=this.vehicleData.insuranceExpiry&&date !=this.vehicleData.permitEnd&&date !=this.vehicleData.fcExpiryDate
    },
  },
  async beforeMount() {
    this.vehicleData = this.$store.getters["vehicle/editVehicleData"]; 
    
    if (this.vehicleData.id !== undefined) {
      this.$store.dispatch("vehicle/getVehicleFileList", this.vehicleData.id);
      try{
                console.log("updatedData",this.vehicleData)

    this.vehicleData=this.$store.state.vehicles.find(i=>i.id===this.vehicleData.id) 
    this.vehicleData ={...this.vehicleData} 

        // const data=this.$store.state.vehicles.find(i=>i.id===this.vehicleData.id)
        console.log("updatedData1",this.vehicleData)
      }
      catch(e){
        console.log("updatedData err",e)
      }
    }

    this.editField = this.$store.getters["vehicle/editField"];
    this.items = this.vehicleData.vehicleGPSDeviceMap;
    this.editId = this.$store.getters["vehicle/editId"];
    
    this.driverListV2 =  this.$store.getters["vehicle/getDrivers"].map (driver => {
         return {
          ...driver,
          displayName: driver.fullName + ` (${driver.contactNumber})`,
        }
    });
    this.vehiclesTypes = this.$store.getters["vehicle/getVehicleTypes"].map (type => {
      return {
        ...type,
        displayName: type.name + ` (${type.type})` 
      }
    });

    if (! this.$route.params.add) { // (add == false) : This page is called for updating the record
      this.vehicleData.driverID = this.driverListV2.find(
        (obj) => obj.id === this.vehicleData.driverID
      );

      if (this.vehicleData.fuelType) {
        this.vehicleData.vehicleFuelType = this.getVehicleFuelTypes.find(
          (obj) => obj.id == this.vehicleData.fuelType
        )
      }
     if (this.vehicleData.model) {
        console.log("vh",this.vehicleData.model,)
        this.vehicleData.model = this.getVehicleModelDropdown.find(
          (obj) => obj == this.vehicleData.model
          
        )
        console.log("vh1",this.vehicleData.model,)
      }


      if (this.vehicleData.vehicleType) {
        this.vehicleData.vehicleType= this.vehiclesTypes.find(vt => vt.id === this.vehicleData.vehicleType)
      }

      this.vehicleData.billingType = this.billingList.find(
        (obj) => obj.billCategory.id == this.vehicleData.billingTypeID
      ); 
      
      this.vehicleData.imeiObj = this.$store.getters["vehicle/getDevices"].find(dev => dev.imei === this.vehicleData.imei);

      this.vehicleData.maintenanceDueDate=new Date(this.vehicleData.maintenanceDueDate);
      this.vehicleData.taxExpiryDate=new Date(this.vehicleData.taxExpiryDate);
      this.vehicleData.insuranceExpiry=new Date(this.vehicleData.insuranceExpiry);
      this.vehicleData.permitEnd=new Date(this.vehicleData.permitEnd);
      this.vehicleData.fcExpiryDate=new Date(this.vehicleData.fcExpiryDate);
      this.vehicleData.emissionExpiry=new Date(this.vehicleData.emissionExpiry);


    }
    
  },
};
</script>
<style>
.file-icon {
  display: inline-block;
  float: left;
  width: 48px;
  height: 48px;
  margin-left: 10px;
  margin-top: 13.5px;
}

.img-file {
  background-image: url(https://demos.telerik.com/kendo-ui/content/web/upload/jpg.png);
}

.file-heading {
  font-family: Arial;
  font-size: 1.1em;
  display: inline-block;
  float: left;
  width: 60%;
  margin: 0 0 0 20px;
  height: 25px;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.file-name-heading {
  font-weight: bold;
  margin-top: 20px;
}

.file-size-heading {
  font-weight: normal;
  font-style: italic;
}

li.k-file div.file-wrapper {
  position: relative;
  height: 75px;
}
@media only screen and (max-width: 768px) {
.mobile_flex_rw{display: flex; overflow: auto;}
.all_input_mbl{
width: 150px !important;
margin: 0px 0px;
}
.driver_header_mobile{flex-direction: row !important; overflow-x: auto;padding: 10px 10px 10px 10px;}
.page-header .title-text {
    font-size: 12px;
    margin-left: 10px;
}
.mobile_side_lbl{width: 70% !important;}
.mobile_side_btn{display: flex;}
}

</style>
